import { Injectable } from '@angular/core';
import { StoreConfig } from '@datorama/akita';
import { DatasourceTableStore } from '@y42/datasource';
import { IntegrationTableGitFactoryService } from './integration-table-git-factory.service';

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'integration-table', idKey: '$path' })
export class IntegrationTableStore extends DatasourceTableStore {
  constructor(protected readonly gitFactory: IntegrationTableGitFactoryService) {
    super('Integration-Table', gitFactory);
  }
}
